import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "delete",
	"data-name": "delete",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M16.88,22.5H7.12a1.9,1.9,0,0,1-1.9-1.8L4.36,5.32H19.64L18.78,20.7A1.9,1.9,0,0,1,16.88,22.5Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 2.45,
			y1: 5.32,
			x2: 21.55,
			y2: 5.32
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M10.09,1.5h3.82a1.91,1.91,0,0,1,1.91,1.91V5.32a0,0,0,0,1,0,0H8.18a0,0,0,0,1,0,0V3.41A1.91,1.91,0,0,1,10.09,1.5Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: 8.18,
			x2: 12,
			y2: 19.64
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 15.82,
			y1: 8.18,
			x2: 15.82,
			y2: 19.64
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 8.18,
			y1: 8.18,
			x2: 8.18,
			y2: 19.64
		})
	]
});
const ForwardRef = forwardRef(SvgDelete);
export default ForwardRef;
